import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv, FlexColumn } from "./common.styles";
import { Subtitle as SharedSubtitle, Text as SharedText } from "./HXDesktopPage.styles";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import Check from "@mui/icons-material/Check";
import { svgGradientStyle } from "./SVGGradients";
import { fontWeights } from "healthex-common/weights";
import { pageHorizontalMargin } from "./HXDesktopPage";
const contentWidth = "700px";
const horizontalPadding = "80px";
const dividerTriangleWidth = "24px";
export const Parent = styled(FlexColumnDiv) `
    align-items: flex-start;
    margin: 48px 0;

    // Fill the full width of the page
    position: relative;
    left: -${pageHorizontalMargin}px;
    width: calc(100% + ${pageHorizontalMargin * 2}px);
`;
export const SectionDividerRectangleContainer = styled(FlexRowDiv) `
    min-width: calc(${contentWidth} + ${horizontalPadding} + ${dividerTriangleWidth});
    height: 24px;
    align-self: stretch;
`;
export const SectionDividerRectangle = styled.div `
    width: calc(${contentWidth} + ${horizontalPadding});
    background-color: ${colors.navy_main};
`;
export const SectionDividerEndTriangle = styled.div `
    width: ${dividerTriangleWidth};
    background: linear-gradient(to bottom left, transparent 0%, transparent 50%, ${colors.navy_main} 50%, ${colors.navy_main} 100%);
`;
export const ContentContainer = styled(FlexColumnDiv) `
    min-width: ${contentWidth};
    padding: 16px ${horizontalPadding} 40px ${horizontalPadding};
    align-items: flex-start;
    align-self: stretch;
    background-color: ${colors.navy_main};
`;
export const SectionContainer = styled(FlexColumn) `
    width: ${contentWidth};
    align-items: flex-start;
`;
export const Logo = styled.img `
    max-height: 24px;
`;
export const Title = styled(SharedSubtitle) `
    color: ${colors.white_main};
    font-size: ${fontSizes.SUPER};
`;
export const Subtitle = styled(SharedSubtitle) `
    color: ${colors.white_main};
    font-size: ${fontSizes.MEDIUM};
`;
export const Text = styled(SharedText) `
    color: ${colors.white_main};
    font-size: ${fontSizes.STANDARD};
    white-space: pre-wrap;
`;
export const TextBold = styled(Text) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const CheckIcon = styled(Check) `
    ${svgGradientStyle("accents_gradient")}
    width: 32px;
    height: 32px;
`;
